import { Accordion, Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import ConditionalSpinner from "../../../../components/ConditionalSpinner";
import { User } from "../../../../models/User";
import { ApplicationState } from "../../../../store";
import { useGetProjectsQuery } from "../../../../store/api/kinesense";
import { AddProject } from "./AddProjectButton";
import { ProjectDetails } from "./ProjectDetails";

interface ProjectsProps {}

export function Projects(props: ProjectsProps) {
    const user = useSelector((state: ApplicationState) => state.user);
    const canViewProjects = User.can(user.permissions.permissions, "read", "projects");
    const { data: projects, isLoading } = useGetProjectsQuery();

    return (
        <Accordion flush style={{ width: "100%" }}>
            <Container className="px-0 mb-2 d-flex justify-content-between">
                <h5 className="mb-0">Projects</h5>
                {canViewProjects && <AddProject {...props} />}
            </Container>

            <ConditionalSpinner isLoading={isLoading}>
                {projects?.map((project) => (
                    <Accordion.Item key={project.projectId} eventKey={project.projectId}>
                        <Accordion.Header>{project.name}</Accordion.Header>
                        <Accordion.Body className="ps-5" style={{ width: "100%" }}>
                            <ProjectDetails key={project.projectId} project={project} />
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </ConditionalSpinner>
        </Accordion>
    );
}
